import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { filter, isEmpty } from 'lodash';
import { useTAApi } from 'modules/codeless-events/providers/TAApiProvider';
import { CONVERSION_CATEGORY } from 'modules/onboarding/OnboardingJourneyForm/components/conversions/consts/marketingObjectivesConfig';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useTrackingApi } from 'services/api';

export const useConversions = () => {
    const { value: conversions = [], onChange: setConversions } = useFormFieldValue({ field: 'newConversion' });
    const { accountId } = useTAApi();
    const { getConversionsList } = useTrackingApi();

    useQuery(
        ['fetchedConversionsList', accountId],
        async () => {
            const data = await getConversionsList(accountId);
            const filteredData =
                filter(
                    data.results,
                    ({ category, isActive }) => isActive && category !== CONVERSION_CATEGORY.ENGAGEMENT
                ) ?? [];
            const processedData = filteredData.map(conversion => ({
                ...conversion,
                touched: false,
            }));
            setConversions(processedData);
        },
        {
            enabled: !!accountId && isEmpty(conversions),
        }
    );
    const touchedConversions = useMemo(() => filter(conversions, conv => conv.touched), [conversions]);
    const untouchedConversions = useMemo(() => filter(conversions, conv => !conv.touched), [conversions]);

    return {
        conversions,
        setConversions,
        touchedConversions,
        untouchedConversions,
    };
};
